import type { IconData } from '@stacksjs/iconify-core'

export const paintBucket: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m412.284 294.37l-12.5 15.642c-8.354 10.454-50.027 64.208-50.027 95.883c0 36.451 28.049 66.105 62.526 66.105s62.527-29.654 62.527-66.105c0-31.675-41.673-85.429-50.028-95.883Zm0 145.63c-16.832 0-30.526-15.3-30.526-34.105c0-11.662 15.485-37.883 30.531-59.2c15.043 21.3 30.522 47.509 30.522 59.2c0 18.805-13.695 34.105-30.527 34.105M122.669 51.492L96.133 124.4L30.092 97.205L17.908 126.8l67.271 27.7L26.9 314.606a48.056 48.056 0 0 0 28.689 61.523l184.719 67.232a48 48 0 0 0 61.523-28.688L397.6 151.56Zm149.1 352.236a16 16 0 0 1-20.508 9.563L66.537 346.059a16 16 0 0 1-9.563-20.507L73.553 280H316.8ZM85.2 248l29.594-81.311l36.333 14.961a32.644 32.644 0 1 0 11.236-29.98l-36.615-15.077l16.046-44.085l214.79 78.177L328 249.219V248Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default paintBucket
